import { API_DOWNLOAD_REPORTE } from "./constants";
require('intl');
require('intl/locale-data/jsonp/es.js');

export const url_query = () => {
  let pl     = /\+/g,  // Regex for replacing addition symbol with a space
      search = /([^&=]+)=?([^&]*)/g,
      decode = function (s) { return decodeURIComponent(s.replace(pl, " ")); },
      query  = window.location.search.substring(1),
      urlParams = {},
      match = search.exec(query);
      if (match)
        match.map( (item, key) =>{
          return urlParams[decode(match[1])] = decode(match[2])
        })

    return urlParams
}

export const validateNumbersOnly = value => {
     return /\d/.test(value);
}

export function getListIdForFilters(filters) {
	let query = "";
  Object.keys(filters).map(function(key) {
		if (key !== "start" && key !== "size")
  		query+= "_" + key +'_'+filters[key];
		return key;
	});
	return `${query}`.toLowerCase();
}

export const isTouchDevice = () => {
  return 'ontouchstart' in document.documentElement;
};


export const sortNumber = (a, b) => {
  return a - b;
}

export const isTouchEvent = (event) => {
  return (
    (event.touches && event.touches.length) ||
    (event.changedTouches && event.changedTouches.length)
  );
}

export const uniqueId = () => {
  return Math.random().toString(36).substring(2) + (new Date()).getTime().toString(36);
}

export const scrollToRef = (ref) =>{
  return ref.current && window.scrollTo(0, ref.offsetTop)
}


export const formatNumberToString = value => {
  const formatter = new Intl.NumberFormat("es-AR", {
    style: 'decimal',
    currency: 'ARS',
  });
  return formatter.format(value)

}
export const formatStringToNumber = value => {
  if (document.documentMode || /Edge/.test(navigator.userAgent)) {
    return value.replace(/\./g,"").replace(/,/g,"")
  }
  return value.replace(/\./g,"").replace(/,/g,".")
}
// Pasos de producción de ECMA-262, Edición 6, 22.1.2.1
// Referencia: https://people.mozilla.org/~jorendorff/es6-draft.html#sec-array.from
if ( !Array.from ) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    // La propiedad length del método from es 1.
    return function from(arrayLike/*, mapFn, thisArg */) {
      // 1. Deje a C ser el este valor.
      var C = this;

      // 2. Deje que los elementos sean ToObject(arrayLike).
      var items = Object(arrayLike);

      // 3. Retornar IfAbrupt(items).
      if (arrayLike === null) {
        throw new TypeError("Array.from requiere un objeto array-like - not null or undefined");
      }

      // 4. Si mapfn no está definida, entonces deja que sea false.
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        // 5. si no
        // 5. a If IsCallable(mapfn) es false, lanza una excepción TypeError.
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: si hay mapFn, el segundo argumento debe ser una función');
        }

        // 5. b. Si thisArg se suministró, deje que T sea thisArg; si no, deje que T esté indefinido.
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }

      // 10. Let lenValue be Get(items, "length").
      // 11. Let len be ToLength(lenValue).
      var len = toLength(items.length);

      // 13. If IsConstructor(C) is true, then
      // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
      // 14. a. Else, Let A be ArrayCreate(len).
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);

      // 16. Let k be 0.
      var k = 0;
      // 17. Repeat, while k < len… (also steps a - h)
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      // 18. Let putStatus be Put(A, "length", len, true).
      A.length = len;
      // 20. Return A.
      return A;
    };
  }());
}

// =========================================
// Validaciones CBU
// desde: https://www.dropbox.com/s/mhqkov4jh6yeuuv/tester_cbu_cuit.zip?dl=0
// =========================================

function validateCBULength(cbu) {
  if (cbu.length !== 22) { return false }
	return true
}

function validateBankCode(codigo) {
  if (codigo.length !== 8) { return false }
  var banco = codigo.substr(0,3)
  var digitoVerificador1 = codigo[3]
  var sucursal = codigo.substr(4,3)
  var digitoVerificador2 = codigo[7]

  var suma = banco[0] * 7 + banco[1] * 1 + banco[2] * 3 + digitoVerificador1 * 9 + sucursal[0] * 7 + sucursal[1] * 1 + sucursal[2] * 3

  var diferencia = (10 - (suma % 10)) % 10;

  return diferencia === digitoVerificador2
 }

function validateAccount(cuenta) {
  if (cuenta.length !== 14) { return false }
  var digitoVerificador = cuenta[13]
  var suma = cuenta[0] * 3 + cuenta[1] * 9 + cuenta[2] * 7 + cuenta[3] * 1 + cuenta[4] * 3 + cuenta[5] * 9 + cuenta[6] * 7 + cuenta[7] * 1 + cuenta[8] * 3 + cuenta[9] * 9 + cuenta[10] * 7 + cuenta[11] * 1 + cuenta[12] * 3
  var diferencia = (10 - (suma % 10)) % 10;
  return diferencia === digitoVerificador
 }

export const validateCBU= cbu => {
 return validateCBULength(cbu) && validateBankCode(cbu.substr(0,8)) && validateAccount(cbu.substr(8,14))
}

// =========================================
// Validaciones CUIT
// desde: https://github.com/miparnisari/arg.js/blob/master/src/cuit.js
// =========================================

 /**
 * @module cuit
 */

var isLengthOk = function(cuit) {
  return (!!cuit && cuit.length === 11);
};

var isTypeOk = function(cuit) {
  if (!cuit || !cuit.substr) return false
  var code = parseInt(cuit.substr(0, 2), 10);
  var validTypes = [20, 23, 24, 27, 30, 33, 34];
  return validTypes.indexOf(code) > -1;
};

var checksumIsOk = function(sCUIT){
  if (!sCUIT) return false
  sCUIT = String(sCUIT);
  var aCUIT = sCUIT.split('');

  var aMult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
  var sum = 0;
  for (var i = 0; i <= 9; i++) {
      sum += aCUIT[i] * aMult[i];
  }

  var diff = 11 - (sum % 11);
  var checksum = Number(aCUIT[10]);

  if (diff === 11) diff = 0; // do not consider diff == 10

  return (diff === checksum);
}

/**
* @description Returns whether a given CUIT or CUIL is valid
* @param {string} cuit
* @returns {boolean} isValid
*/
export const isCuitValid = function(cuit) {
return isLengthOk(cuit) && isTypeOk(cuit) && checksumIsOk(cuit);
};

// module.exports = {
//   isLengthOk: isLengthOk,
//   checksumIsOk: checksumIsOk,
//   isTypeOk: isTypeOk,
//   isValid: isValid
// };

// =========================================
// Validaciones varias
// desde: https://www.dropbox.com/s/mhqkov4jh6yeuuv/tester_cbu_cuit.zip?dl=0
// =========================================

export const validateEmail = email => {
  const re=/^([\da-zA-Z_.-]+)@([\da-zA-Z.-]+).([a-zA-Z]{2,6})$/
  //const re = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.([A-Za-z]{2,6})$/
  return re.test(email);
}

export const validateName = n =>{
  return /^[a-zA-ZàáéíóúüñÁÉÍŃÓÚÑ ]+$/u.test(n);
}

if (typeof Object.assign != 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target, varArgs) { // .length of function is 2

      if (target === null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      var to = Object(target);

      for (var index = 1; index < arguments.length; index++) {
        var nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (var nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

Number.isInteger = Number.isInteger || function(value) {
  return typeof value === 'number' &&
    isFinite(value) &&
    Math.floor(value) === value;
};

export const getLinkPDFOrderPracticesFiltered = (base_link_order_pdf, practices_selected) => {
    let pdf_link = base_link_order_pdf
    let ids = practices_selected
    
    if(pdf_link && ids && ids.length) {
      pdf_link += '/'
      ids.forEach((id, index) => {
          pdf_link += id
          if(index !== (ids.length-1)) pdf_link += '-'
        });
    }

    return pdf_link
}

export const getLinkEXCELInfoPrestador = (date_start, date_end) => {
    let url = date_start.getFullYear() + '-' + (date_start.getMonth() + 1) + '-' + date_start.getDate() + '/'
        + date_end.getFullYear() + '-' + (date_end.getMonth() + 1) + '-' + date_end.getDate();

    return API_DOWNLOAD_REPORTE + '/' + url;
}